var React = require('react');

function ChevronGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 4L3.6 1L6 4","stroke":"#2F7444"}));
}

ChevronGreen.defaultProps = {"width":"7","height":"5","viewBox":"0 0 7 5","fill":"none"};

module.exports = ChevronGreen;

ChevronGreen.default = ChevronGreen;
